import React from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useApp();
  if (user === null) {
    return <div className="min-h-[60vh] grid place-items-center text-muted-foreground">Caricamento…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "superadmin") return <Navigate to="/" replace />;
  return children;
}
